import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'cuponesEC',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      comercios_f: [],
      f_c: {
        fecha: this.date_rest(this.currentdate(), -10),
        estado: false
      }
    }
  },
  computed: {
    reporte: function () {
      return '/reportes/devoluciones?dsis=' + window.sssdi + '&fecha=' + this.f_c.fecha + '&estado=' + this.f_c.estado
    }
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  unmounted() {
    this.tbv.destroy();
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },
    });
    $('.box').boxWidget();
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/devoluciones', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          response.data.data.forEach(e => {
            e[10] = this.num_to_many(e[10]);
            e[11] = this.num_to_many(e[11]);
            e[13] = this.num_to_many(e[13]);
            e[18] = this.num_to_many(e[18]);
            e[19] = this.num_to_many(e[19]);
            e[20] = this.num_to_many(e[20]);
            e[21] = this.num_to_many(e[21]);
            this.tbv.row.add(e);
          });
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/devoluciones/index.js